<template>
  <div class="file__file-item">
    <div class="d-flex flex-column justify-content-center">
      <div class="file__file-item__container" @click="downloadFile">
        <img v-if="isImage(file.format)" class="file__file-item__photo" :src="file.url" />
        <svg
          v-else-if="isPDF(file.format)"
          class="m-show-files-content-files-item-container-icon"
          width="33"
          height="33"
          viewBox="0 0 33 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M1.5 31.5V1.5H31.5V31.5H1.5Z" stroke="#E30000" stroke-width="3" />
          <path
            d="M18.4486 14.7397C17.205 15.7354 17.1654 15.7596 16.431 16.3868C15.6967 17.014 15.4226 17.1035 14.1731 18.0923M18.4486 14.7397C22.6951 13.107 23.8297 9.49956 20.8864 8.43992C17.943 7.38027 16.3731 10.9298 18.4486 14.7397ZM18.4486 14.7397C18.7117 16.2779 18.7225 16.2654 18.8943 17.2736C19.0695 18.3012 19.0607 18.4132 19.3329 19.95M14.1731 18.0923C15.6889 18.6333 16.7871 19.0334 16.7871 19.0334C16.7871 19.0334 17.8203 19.4006 19.3329 19.95M14.1731 18.0923C10.584 15.3615 6.77769 16.2174 7.29796 19.2059C7.81822 22.1944 11.7902 21.731 14.1731 18.0923ZM19.3329 19.95C23.8993 20.1552 26.1933 23.2073 23.7703 25.1362C21.3472 27.065 18.6614 24.2047 19.3329 19.95Z"
            stroke="#E30000"
            stroke-width="2"
          />
        </svg>
        <svg
          v-if="isDocxFile(file.format)"
          width="33"
          height="33"
          viewBox="0 0 33 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M26.8035 8.296L24.3795 25H17.9475L16.4595 13L14.8035 25H8.5155L6.1875 8.296H11.1315L12.1875 21.424L13.9635 8.296H19.1235L20.6115 21.424L22.0515 8.296H26.8035Z"
            fill="#2B579A"
          />
          <path d="M1.5 31.5V1.5H31.5V31.5H1.5Z" stroke="#2B579A" stroke-width="3" />
        </svg>

        <div class="m-show-files-content-files-item-overlay">
          <svg
            v-if="isImage(file.format)"
            width="36"
            height="22"
            viewBox="0 0 36 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M34 11C34 11 26.8366 21 18 21C9.16344 21 2 11 2 11C2 11 9.16344 1 18 1C26.8366 1 34 11 34 11Z"
              stroke="white"
              stroke-width="2"
            />
            <path
              d="M24 9C24 12.3137 21.3137 15 18 15C14.6863 15 12 12.3137 12 9C12 5.68629 14.6863 3 18 3C21.3137 3 24 5.68629 24 9Z"
              stroke="white"
              stroke-width="2"
            />
          </svg>

          <svg
            v-if="isPDF(file.format) || isDocxFile(file.format)"
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.70711 12.2929C7.31658 11.9024 6.68342 11.9024 6.29289 12.2929C5.90237 12.6834 5.90237 13.3166 6.29289 13.7071L7.70711 12.2929ZM13 19L12.2929 19.7071C12.6834 20.0976 13.3166 20.0976 13.7071 19.7071L13 19ZM19.7071 13.7071C20.0976 13.3166 20.0976 12.6834 19.7071 12.2929C19.3166 11.9024 18.6834 11.9024 18.2929 12.2929L19.7071 13.7071ZM14 1C14 0.447715 13.5523 0 13 0C12.4477 0 12 0.447715 12 1H14ZM26 19C26 18.4477 25.5523 18 25 18C24.4477 18 24 18.4477 24 19H26ZM2 19C2 18.4477 1.55228 18 1 18C0.447715 18 0 18.4477 0 19H2ZM6.29289 13.7071L12.2929 19.7071L13.7071 18.2929L7.70711 12.2929L6.29289 13.7071ZM13.7071 19.7071L19.7071 13.7071L18.2929 12.2929L12.2929 18.2929L13.7071 19.7071ZM14 19V1H12V19H14ZM24 19V23H26V19H24ZM23 24H3V26H23V24ZM2 23V19H0V23H2ZM3 24C2.44772 24 2 23.5523 2 23H0C0 24.6569 1.34315 26 3 26V24ZM24 23C24 23.5523 23.5523 24 23 24V26C24.6569 26 26 24.6569 26 23H24Z"
              fill="white"
            />
          </svg>
        </div>
      </div>

      <div class="file__file-item__name">{{ file.name }}</div>
    </div>

    <c-button
      v-b-popover.html="{
        container: '#app',
        trigger: 'hover blur',
        content: 'Удалить',
        placement: 'top',
      }"
      class="file__file-item__trash"
      size="iconic"
      icon="trash"
      @click="removeImage(file.name)"
    />
  </div>
</template>

<script>
import Button from "@/components/controls2/Button";
import { DOCS_EXTENSIONS, IMAGE_EXTENSIONS } from "@/utils/files";
import { downloadDocument } from "@/utils/download";

export default {
  name: "file-template-component",
  components: {
    "c-button": Button,
  },
  props: {
    file: {
      type: Object,
      default: () => ({
        format: "",
        url: "",
        name: "",
      }),
    },
  },
  methods: {
    removeImage() {
      this.$emit("remove-image");
    },

    isImage(fileFormat) {
      return IMAGE_EXTENSIONS.includes(fileFormat);
    },
    isPDF(fileFormat) {
      return fileFormat === "pdf";
    },
    isDocxFile(fileFormat) {
      return DOCS_EXTENSIONS.includes(fileFormat);
    },
    downloadFile() {
      if (this.isImage(this.file.format)) {
        return;
      }

      downloadDocument(this.file.url, this.file.name);
    },
  },
};
</script>

<style lang="scss" scoped>
.file {
  &__file-item {
    display: flex;

    &__container {
      height: 102px;
      width: 136px;
      display: flex;
      justify-content: center;
      border: 1px solid #dfe4ef;
      border-radius: 6px;
      cursor: pointer;
      align-items: center;
      position: relative;

      &:hover .m-show-files-content-files-item-overlay {
        background-color: rgba(0, 0, 0, 0.7);
      }

      &:hover .m-show-files-content-files-item-overlay svg {
        display: block;
      }
    }

    &__photo {
      width: 136px;
      object-fit: cover;
      height: 102px;
      box-sizing: border-box;
      border-radius: 6px;

      &__view-mode {
        width: 100%;
        height: 100%;
      }
    }
    &__name {
      margin-top: 7px;
      text-align: center;
      font-weight: 500;
      font-size: 12px;
      line-height: 108%;
      padding: 0 0 3px 0;
      white-space: nowrap;
      max-width: 136px;
      overflow: hidden;
      text-overflow: ellipsis;

      @media screen and (max-width: 700px) {
        max-width: 108px;
      }
    }
    &__trash {
      margin-left: 3px;
    }
  }
}
.m-show-files-content-files-item-overlay {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  pointer-events: none;
  background: transparent;
  border-radius: 6px;
  top: 0;
  left: 0;

  & svg {
    display: none;
  }

  @media screen and (max-width: 700px) {
    height: 81px;
  }

  @media screen and (max-width: 420px) {
    height: 100px;
  }
}
</style>
